export default __webpack_public_path__ + "static/media/chef.e8aefaeb.png";